//@ts-ignore
import { useChat, Message } from "ai/react";
import { params } from "@/params";
import { useAuthorizedMutation } from "@/api";

export const useBadFeedback = ({ isChat }: { isChat: boolean }) => {
  return useAuthorizedMutation({
    url: isChat
      ? `${params.API_URL}/platform/vercel-proxy/api/reply-chat/train?stream=false&playground=true&simulator=true`
      : `${params.API_URL}/platform/vercel-proxy/api/reply?stream=false&playground=true&simulator=true`,
    method: "POST",
  });
};

export const usePositiveFeedback = () => {
  const oldAiMutation = useAuthorizedMutation({
    url: `${params.API_URL}/platform/vercel-proxy/api/rag`,
    method: "PUT",
  });

  const newAiMutation = useAuthorizedMutation({
    url: `${params.API_URL}/platform/vercel-proxy/api/chunking-embedding/utils/verified-answers`,
    method: "PUT",
  });

  return {
    mutateAsync: async (
      data: Parameters<typeof oldAiMutation.mutateAsync>[0]
    ) => {
      const oldAiPromise = oldAiMutation.mutateAsync(data);
      const newAiPromise = newAiMutation.mutateAsync(data).catch((error) => {
        console.error("failed to embed verified answers to ai-v2", {
          error: error instanceof Error ? error.message : String(error),
        });
      });
      await Promise.allSettled([oldAiPromise, newAiPromise]);
      return await oldAiPromise;
    },
  };
};
export const useForgetFeedback = () => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/vercel-proxy/api/rag/delete`,
    method: "POST",
  });
};

export const useHandleInstructify = () => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/vercel-proxy/api/instructify`,
    method: "POST",
  });
};
